import { Link } from "react-router-dom";
import MainHeading from "../regular/global/MainHeading";

export default function Placeholder({h}) {
    return <Link target='_blank' style={{textDecoration: 'none'}} to='/stranica/marketing'>
        <div style={{width: '100%', textAlign: 'center', height: h || 'auto', backgroundColor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <MainHeading redText='Mjesto za vašu reklamu' />
        </div>
    </Link>
}